<template>
<div class="hero-container">
  <div class="hero-img">
    <div class="overlay-container">
      <div class="hero-overlay">
        <div class="line-head-container">
          <div class="white-line"></div>
          <h1 class="head-bottom">FleetREDI</h1>
          <div class="white-line"></div>
        </div>
        <h2 class="head-large">Fleet Research, Energy Data, and Insights</h2>
        <p class="head-description">
          FleetREDI is an interactive online portal for sharing, discovering, and analyzing integrated commercial vehicle data and energy insights.
        </p>
        <div class="hero-btn-container">
          <a class="hero-btn" href="#" @click.prevent="scrollToBottom()">Learn More</a>
          <router-link class="hero-btn" to="/dashboard">Get Insights</router-link>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script setup>

function scrollToBottom() {
  const aboutSection = document.getElementById('about-section');
  aboutSection.scrollIntoView();
  aboutSection.focus();
}

</script>
